import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const fmtMins = (m) => `${Math.floor((m||0)/60)}h ${(m||0)%60}m`;
const fmtDate = (d) => new Date(d).toLocaleDateString("en", { month: "short", day: "2-digit", year: "numeric" });
const fmtTime = (i) => i ? new Date(i).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : "—";

export default function Attendance() {
  const { user } = useAuth();
  const [mine, setMine] = useState([]);
  const [all, setAll] = useState([]);
  const [tab, setTab] = useState("mine");
  const canSeeAll = user.role !== "employee";

  useEffect(() => {
    api.get("/attendance/mine").then(r => setMine(r.data));
    if (canSeeAll) api.get("/attendance/all").then(r => setAll(r.data));
  }, [canSeeAll]);

  const rows = tab === "mine" ? mine : all;

  return (
    <div>
      <div className="border-b border-border px-8 lg:px-12 py-8">
        <div className="eyebrow mb-2">People / Attendance</div>
        <h1 className="font-display text-4xl font-black tracking-tight">Attendance log</h1>
        <p className="text-sm text-muted-foreground mt-2">Multi-session check-in/out with total work + break time.</p>
        {canSeeAll && (
          <div className="mt-6 flex gap-0 border border-border w-fit">
            <button onClick={() => setTab("mine")} className={`px-6 py-2 text-sm font-medium ${tab === "mine" ? "bg-[#0A0A0A] text-white" : "hover:bg-muted"}`} data-testid="tab-my-attendance">My log</button>
            <button onClick={() => setTab("all")} className={`px-6 py-2 text-sm font-medium border-l border-border ${tab === "all" ? "bg-[#0A0A0A] text-white" : "hover:bg-muted"}`} data-testid="tab-all-attendance">Everyone</button>
          </div>
        )}
      </div>
      <div className="p-8 lg:p-12">
        <div className="border border-border">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-border bg-muted">
                {tab === "all" && <th className="text-left px-4 py-3 eyebrow">Employee</th>}
                <th className="text-left px-4 py-3 eyebrow">Date</th>
                <th className="text-left px-4 py-3 eyebrow">Sessions</th>
                <th className="text-right px-4 py-3 eyebrow">Work</th>
                <th className="text-right px-4 py-3 eyebrow">Break</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} className="border-b border-border hover:bg-muted/50" data-testid={`att-row-${r.id}`}>
                  {tab === "all" && <td className="px-4 py-3 font-medium">{r.user_name}</td>}
                  <td className="px-4 py-3 font-mono-mini">{fmtDate(r.date)}</td>
                  <td className="px-4 py-3">
                    <div className="flex gap-2 flex-wrap">
                      {(r.sessions || []).map((s, i) => (
                        <span key={i} className="font-mono-mini text-xs border border-border px-2 py-0.5">
                          {fmtTime(s.check_in)}→{fmtTime(s.check_out)}
                        </span>
                      ))}
                      {(r.breaks || []).map((b, i) => (
                        <span key={`b${i}`} className="font-mono-mini text-xs border border-[#F59E0B] text-[#F59E0B] px-2 py-0.5" title="Break">
                          ☕ {fmtTime(b.start)}→{fmtTime(b.end)}
                        </span>
                      ))}
                    </div>
                  </td>
                  <td className="px-4 py-3 text-right font-mono-mini text-[#002FA7] font-semibold">{fmtMins(r.total_work_minutes)}</td>
                  <td className="px-4 py-3 text-right font-mono-mini text-[#F59E0B]">{fmtMins(r.total_break_minutes)}</td>
                </tr>
              ))}
              {rows.length === 0 && <tr><td colSpan={5} className="p-8 text-center text-muted-foreground">No records yet</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
